import Functions from '@client/style/Functions';
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { ImageData } from '../Image';
import SimpleImageCarouselEntry from './SimpleImageCarouselEntry';
import { Breakpoints } from '@client/style/Variables';
import LeftArrowButton from '@client/assets/svgs/left-arrow-button.svg';
import CarouselContainer, { ImperativeCarousel } from './simple/CarouselContainer';

const Container = styled.div<{ $bg: string }>`
	width: 100%;
	background-color: ${props => props.$bg};
	padding-top: 40px;
	padding-bottom: 40px;
	position: relative;
	padding-left: var(--gridGutter);

	${Functions.breakpoint(Breakpoints.tablet)} {
		padding-top: 120px;
		padding-left: calc(${Functions.col(3, 16, 1)});
	}

	&:has(+ .BreakerModule) {
		border-bottom: var(--breaker-total) solid transparent;
	}
`;

const StyledCarousel = styled(CarouselContainer)`
	grid-auto-columns: max-content;
	gap: var(--gridGutter);
	align-items: end;
	padding-right: var(--gridGutter);
`;

const LeftArrowSvg = styled(LeftArrowButton)<{ $disabled: boolean }>`
	position: absolute;
	left: calc(var(--gridGutter) * 0.5);
	top: 50%;
	transform: translateY(-50%);
	display: none;
	cursor: pointer;
	z-index: 5;
	opacity: ${props => (props.$disabled ? '0' : '1')};
	pointer-events: ${props => (props.$disabled ? 'none' : 'all')};
	transition: opacity 0.2s;

	${Functions.breakpoint(Breakpoints.mobile)} {
		display: block;
	}

	${Functions.breakpoint(Breakpoints.tablet)} {
		left: var(--gridMargin);
	}
`;

const RightArrowSvg = styled(LeftArrowSvg)`
	left: unset;
	right: calc(var(--gridGutter) * 0.5);
	transform: scale(-1, 1) translateY(-50%);

	${Functions.breakpoint(Breakpoints.tablet)} {
		right: var(--gridMargin);
	}
`;

interface IProps {
	data: {
		images: { text: string; image: ImageData }[];
		backgroundColorLink: any;
		loop?: boolean;
	};
}

export default function SimpleImageCarousel({ data }: IProps) {
	const carouselRef = useRef<ImperativeCarousel>(null);

	const [activeIndex, setActiveIndex] = useState(0);

	return (
		<Container $bg={data.backgroundColorLink?.color} className='colorWrapperAnimatedModule'>
			<LeftArrowSvg
				onClick={() => {
					carouselRef.current?.move(-1);
				}}
				$disabled={activeIndex <= 0 && !data.loop}
			/>
			<StyledCarousel loop={data.loop} onMove={setActiveIndex} ref={carouselRef}>
				{data.images.map((image, index) => {
					return <SimpleImageCarouselEntry key={index} image={image.image} text={image.text} />;
				})}
			</StyledCarousel>
			<RightArrowSvg
				onClick={() => {
					carouselRef.current?.move(1);
				}}
				$disabled={activeIndex >= data.images.length - 1 && !data.loop}
			/>
		</Container>
	);
}
